export default {
    login: '로그인',
    logout: '로그아웃',
    register: '신규 등록',
    upload: '업로드',
    name: '이름',
    email: '메일 주소',
    password: '패스워드',
    passwordConfirmation: '패스워드(확인용)',
    isCommunityManager: 'Community Manager',
    dashboard: '대시보드',
    offerLists: '오퍼리스트',
    schedule: '스케쥴',
    accountEdit: '계정 정보의 수정',
    edit: '편집',
    detail: '상세사항',
    fullname: '{{lastname}} {{firstname}}',
    quantity: '개수',
    quantityWithWeight: '개수 (중량)',
    confirmTitle: '확인',
    orderInformation: '예약정보',
    orderPrices: '가격변경 이력',
    invoices: '청구서',
    contact: '문의하기',
    when: '시간',
    add_to_google_calendar: 'Google Calendar에 추가',
    pages: {
        dashboard: {
            unpaidInvoices: {
                title: 'Unpaid invoices (10 unpaid invoices are displayed order by expired date)',
                totalUnpaidAmountAll: 'Unpaid invoices(all)',
                totalUnpaidAmountExpired: 'Unpaid invoices(expired)',
                more: 'view all',
            },
            typicaStockItemDelaySummaryPanel: {
                title: 'TYPICA selection residency status',
                chartTitleFromImported: 'imported to purchased',
                chartTitleFromPurchased: 'purchased to delivered',
                within1month: 'within 1month',
                within2month: 'within 2months',
                within3month: 'within 3months',
                within4month: 'within 4months',
                within5month: 'within 5months',
                over5month: 'over 5month',
                unitLabel: 'Weight(Kg)',
            },
            remainingWarehouseItems: {
                title: 'Pending status of pre-orders (Lump-sum payment after the initial delivery or Pay per delivery)',
                subTitles: {
                    byPeriod: 'By Period',
                    byCommunityManager: 'By Community manager',
                    byOffice: 'By Office',
                },
                more: 'view all',
                unitLabel: 'Weight(Kg)',
            },
        },
        offerUpload: {
            title: '업로드 CSV',
            producer: 'Producer',
            download: 'CSV 템플릿이 있습니다',
            sampleDeliveryDateMemo: '오퍼 개시 희망일의 14일 이전이어야 합니다',
            uploadMemo: '업로드 완료 후 담당자가 추후 연락드리겠습니다',
            suggestToCreateBankAccountText: "\uC218\uC775\uAE08\uC744 \uC218\uB839\uD558\uAE30 \uC704\uD574\uC11C\uB294 \uACC4\uC88C \uC815\uBCF4\uB97C \uBC18\uB4DC\uC2DC \uB4F1\uB85D\uD574\uC57C \uD569\uB2C8\uB2E4.\nSales Contract \uBC1C\uD589 \uC2DC \uACC4\uC88C\uC815\uBCF4\uAC00 \uBC18\uB4DC\uC2DC \uD544\uC694\uD558\uBBC0\uB85C, \uC624\uD37C \uB9AC\uC2A4\uD2B8\uB97C \uC5C5\uB85C\uB4DC\uD558\uC2DC\uB294 \uC2DC\uC810\uC5D0 \uB4F1\uB85D\uD558\uC2DC\uB294 \uAC83\uC744 \uAD8C\uACE0\uB4DC\uB9BD\uB2C8\uB2E4.",
        },
        offerList: {
            title: '{{country}} / {{ name }} 의 오퍼리스트',
            createInvoices: '청구서를 발행하기',
            createInvoicesExplanation: "\uB2E4\uB4F1\uB85D\uB41C \uC608\uC57D\uC815\uBCF4 \uB0B4\uC5D0\uC11C \uC9C0\uBD88\uC2DC\uC810\uC774 \u300C1. \uC0DD\uC0B0\uC790\uC758 \uD76C\uB9DD\uB300\uB85C \uC77C\uC2DC\uBD88 \uC9C0\uBD88\u300D \uC778 \uAC83\uC5D0 \uB300\uD558\uC5EC \uC77C\uAD04\uB85C \uCCAD\uAD6C\uC11C\uB97C \uBC1C\uD589\uD569\uB2C8\uB2E4.\n\uB9CC, \uC774\uBBF8 \uCCAD\uAD6C\uC11C\uAC00 \uBC1C\uD589\uB41C \uC608\uC57D\uC5D0 \uB300\uD558\uC5EC\uB294 \uC2E0\uADDC\uB85C \uCCAD\uAD6C\uC11C\uB97C \uC791\uC131\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.\n\uC0DD\uC131\uB41C \uCCAD\uAD6C\uC11C\uC758 URL\uC740 \uAC01 \uB85C\uC2A4\uD130\uC5D0\uAC8C \uC774\uBA54\uC77C\uB85C \uD1B5\uC9C0\uB429\uB2C8\uB2E4.",
            sampleOrderStock: {
                quantity: '샘플 재고 배분',
                lotVisibleLabel: 'Show/Hide Lot',
                show: 'Show',
                hide: 'Hide',
            },
            publishedCountriesTableTitle: '판매국',
            basicInformations: '기본정보',
            publishedCountriesTable: '판매국',
            transportToWarehouseTable: '창고단위수송정보',
            officeDetailTable: 'Office Information',
            offersTable: '오퍼',
            contracts: 'Contracts',
            sampleOrderPeriod: '샘플 접수일',
            orderPeriod: '예약 접수일',
            paymentPeriod: '지불시기',
            estimatedDeliveryPeriod: '도착예정',
            paymentAfterDelivery: '납품후 후불',
            paymentPeriods: {
                reserved: '예약시 선불',
                exported: '수출시 지불',
                imported: '입항시 지불',
                delivered: '로스터님께 납품 시',
            },
            installmentPaymentAfterImport: '입고 후 분할결제',
            installmentPayment: '분할결제',
            estimatedPaymentDateFormat: '{{year}} {{month}} {{date}}',
            installmentPaymentsHelp: {
                title: '후불에 관해',
                body: "\uC608\uC57D\uC2DC\uC5D0 \"\uB0A9\uD488\uD6C4 \uD6C4\uBD88\"\uC744 \uC120\uD0DD\uD558\uBA74, \uB0A9\uD488\uD6C4\uC5D0 \uC9C0\uBD88\uD558\uB294\uAC83\uC774 \uAC00\uB2A5\uD569\uB2C8\uB2E4.\n\uCCAB \uB0A9\uD488\uD6C4\uC5D0, \"\uC804\uC561 \uD6C4\uBD88\" \uD639\uC740 \uCC3D\uACE0\uBCF4\uAD00\uBD84\uC744 \uB0A9\uD488\uD560\uB54C\uB9C8\uB2E4 \"\uB9E4\uBC88 \uD6C4\uBD88\"\uC911 \uD558\uB098\uB97C \uC120\uD0DD\uD558\uC2E4 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
            },
            FreeOnBoardHelp: {
                title: 'FOB란?',
                body: "\uC0DD\uC0B0\uAD6D\uC758 \uD56D\uAD6C\uC5D0 \uB3C4\uCC29\uD55C \uC2DC\uC810\uC758 \uC0DD\uB450 \uAC00\uACA9\uC785\uB2C8\uB2E4.\n\uD574\uC0C1\uC6B4\uC784\uC774\uB098 \uC218\uC785\uC218\uC218\uB8CC\uB294 \uD3EC\uD568\uB418\uC5B4\uC788\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
            },
            estimatedDeliveryPeriodFormat: '{{year}} {{month}} {{monthPart}}',
            okagesamaNoMori: 'OKAGESAMA',
            okagesamaNoMoriContributors: 'OKAGESAMA Contributors',
            okagesamaNoMoriTotalPrices: 'OKAGESAMA Total prices',
            okagesamaNoMoriStatuses: {
                title: 'OKAGESAMA Statuses',
                joined: 'Joined',
                paid: 'Joined(Paid)',
            },
        },
        editProfile: {
            title: '프로필 편집',
            subTitle: '고객정보',
            questionnairesForRoaster: '로스터로서의 앙케이트',
            questionnairesForRoasterMemo: '* 아래 내용은 나중에 변경할 수 있습니다',
            cannotChangeCountry: '* 소속국은 한번 등록하면 변경이 불가하오니 주의하시기 바랍니다',
        },
        editAccount: {
            title: '계정 정보를 편집',
            currentEmail: '현재의 메일 주소',
            warning: "\uBA54\uC77C \uC8FC\uC18C\uB97C \uBCC0\uACBD \uD6C4, \uD55C\uBC88 \uB85C\uADF8\uC544\uC6C3 \uB429\uB2C8\uB2E4.\n\uC0C8\uB85C\uC6B4 \uBA54\uC77C \uC8FC\uC18C\uB85C \uD655\uC778\uC6A9 \uBA54\uC77C\uC774 \uC1A1\uC2E0\uB418\uC624\uB2C8 \uAE30\uC7AC\uB41C \uB9C1\uD06C\uB97C \uD074\uB9AD\uD558\uC2DC\uBA74 \uBC18\uC601\uC774 \uC644\uB8CC\uB429\uB2C8\uB2E4.\n\uADF8 \uD6C4, \uC0C8\uB85C\uC6B4 \uBA54\uC77C\uC8FC\uC18C\uB85C \uB85C\uADF8\uC778\uD558\uC2E4 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
        },
        exchangeRates: {
            title: '환율 설정',
            exchangeRateColumnTitle: 'USD/{{ currency }}환산',
        },
        roasterOfferLists: {
            sampleRequest: '샘플 요청',
            order: '예약',
            inactive: '공개 종료',
        },
        roasterOrder: {
            title: '{{ listName }}의 예약',
            explanationSelectOffers: '·아래 목록에서 재고 수를 확인한 후, 예약 수량을 선택해 주세요.',
            explanationAuctionWithFobPriceUsdPerLb: '* 경매 결과는 USD/Kg에 의한 결과입니다. (1kg=2.20462lb)',
            explanationStockMightChange: '* 화면이 켜진 동안에 재고가 없어지는 경우가 있습니다. 양해 부탁드립니다.',
            order: '예약',
            orderAmount: '예약',
            totalFee: '총 금액: {{ fee }} (세금 포함)',
            totalBags: '총 마대 수: {{ amount }}마대',
            totalOrderedBags: '주문 완료 마대 수: {{ amount }}마대',
            totalWeight: '총 중량: {{ weight }}Kg',
            totalOrderedWeight: '주문한 무게: {{ weight }}Kg',
            totalOneTimeUpfrontOrderedBags: '선결제 마대수: {{ amount }}마대',
            typicaHandlingFee: 'TYPICA 수수료: {{ percentage }}%',
            typicaHandlingFeeExplanationByBagCount: '5마대 미만 {{ lessThan5Bags }} / 5마대 이상 {{ moreThan5Bags }} / 10마대 이상 {{ moreThan10Bags }} / 50마대 이상 {{ moreThan50Bags }}',
            typicaHandlingFeeExplanationByWeight: '300Kg 미만: {{ lessThan300Kg }} / 300Kg 이상: {{ moreThan300Kg }} / 600Kg 이상: {{ moreThan600Kg }} / 3,000Kg 이상: {{ moreThan3000Kg }}',
            details: '내역',
            paymentAndDelivery: '지불 방법 및 배송지 주소',
            paymentMethodExplanation: "* \uC2E0\uC6A9\uCE74\uB4DC\uC758 \uC774\uC6A9\uD55C\uB3C4\uB098, \uD560\uBD80\uC870\uAC74\uC740 \uACB0\uC81C\uC790\uC758 \uCE74\uB4DC \uACC4\uC57D \uC870\uAC74\uC5D0 \uB530\uB77C \uB2EC\uB77C\uC9D1\uB2C8\uB2E4. \uC790\uC138\uD55C \uB0B4\uC6A9\uC740 \uD574\uB2F9 \uC2E0\uC6A9\uCE74\uB4DC \uD68C\uC0AC\uC5D0 \uBB38\uC758\uB97C \uBD80\uD0C1\uB4DC\uB9BD\uB2C8\uB2E4.\n        * 1\uD68C \uACB0\uC81C \uAE08\uC561\uC774, 10,000,000\uC6D0\uC744 \uCD08\uACFC\uD560 \uACBD\uC6B0 \uACC4\uC88C \uC774\uCCB4\uB85C \uC9C0\uBD88 \uBC29\uBC95\uC774 \uBCC0\uACBD\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uC591\uD574 \uBD80\uD0C1 \uB4DC\uB9BD\uB2C8\uB2E4.",
            endOfMonth: '월말까지',
            oneTimeUpfrontExplanations: '- 결제 기일은 {{ paymentDate }} 입니다. 상세한 내용은 오퍼 종료 후 발행되는 청구서를 확인해 주시길 바랍니다.',
            afterImportPaymentExplanations: "- \uCEE4\uD53C \uC785\uACE0 \uD6C4 (\uC608\uC0C1 \uC785\uACE0\uC77C: {{ deliveryPeriod }}) \uBD80\uD130 14\uC77C \uC774\uB0B4 \uACB0\uC81C \uBC14\uB78D\uB2C8\uB2E4.\n      - \uBC30\uC1A1\uC740 \uACB0\uC81C \uC644\uB8CC \uD6C4 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
            fewTimesPaymentAfterImportExplanations: "- \uCCAB \uACB0\uC81C\uC77C\uC740 \uC785\uACE0\uC77C(\uC608\uC0C1 \uC785\uACE0\uC77C: {{ deliveryPeriod }}) \uBD80\uD130 14\uC77C \uC774\uB0B4\uC785\uB2C8\uB2E4.\n      - \uCCAB \uBC88\uC9F8 \uACB0\uC81C\uAC00 \uC644\uB8CC\uB41C \uD6C4, \uBC30\uC1A1\uC774 \uAC00\uB2A5\uD569\uB2C8\uB2E4.\n      - \uB450 \uBC88\uC9F8 \uC774\uD6C4\uC758 \uACB0\uC81C\uB294, \uC785\uACE0 \uD6C4 \uB2E4\uC74C \uB2EC \uB9D0\uAE4C\uC9C0\uC785\uB2C8\uB2E4. \uC0C1\uC138\uD55C \uB0B4\uC6A9\uC740 \uC6D4\uCD08 \uBC1C\uD589\uB418\uB294 \uCCAD\uAD6C\uC11C\uB97C \uD655\uC778\uD574 \uC8FC\uC2DC\uAE38 \uBC14\uB78D\uB2C8\uB2E4.",
            paymentTimingExplanation: '* 결제 시점에 따라 수수료가 다릅니다. 자세한 내용은 화면 하단의 가격 시뮬레이터를 참조하시기 바랍니다.',
            oneTimeUpfrontRateConstraintByBagAmount: ' (2마대 이상 예약에 한합니다)',
            oneTimeUpfrontRateConstraintByWeight: ' (120Kg 이상의 예약에 한함)',
            deliveryMethodExplanation: "* \uB2F9\uC0AC \uCC3D\uACE0\uC5D0 \uC785\uACE0\uB41C \uB0A0\uC758 \uB2E4\uC74C \uB2EC 1\uC77C\uBD80\uD130 1kg\uB2F9 \uC6D4 {{unitPrice}}\uC758 \uBCF4\uAD00\uB8CC\uAC00 \uBD80\uACFC\uB429\uB2C8\uB2E4.",
            oneTimeUpfrontRateByBagAmount: '({{ percentage }} 할인이 * 2마대 이상 예약에 한합니다)',
            oneTimeUpfrontRateByWeight: ' | -{{ percentage }} 할인',
            paymentTimingNegativeRate: ' | -{{ percentage }} 할인',
            paymentTimingPositiveRate: ' | 결제 수수료 {{ positive }}{{ percentage }}',
            addressExplanation: '* 맨션명, 호실 등의 기입 누락에 주의해 주십시오.',
            emailExplanation: '* 메일주소의 잘못된 입력에 주의해 주세요.',
            deliveryTimeEtcExplanation: '* 배송시간의 지정등, 희망하신 사항에 따르는 것이 불가능한 경우가 있으니 양해를 부탁 드립니다.',
            sample: '샘플',
            sampleOrder: '샘플 청구',
            sampleOrdered: '예약 완료',
            outOfSamples: '샘플 재고없음',
            bidSubmitted: '입찰 완료',
            sampleOrderableCount: '샘플 청구가능한 Lot 수량',
            inputAddress: '주소 입력으로',
            simulateAndInputAddress: '가격 상세 및 주소 입력으로',
            simulation: '가격 시뮬레이션',
            sampleOrderCaption: '이하 Lot의 샘플을 예약합니다',
            comment: '코멘트',
            commentHelp: '* 코멘트는 생산자나 다른 로스터에게 공유됩니다',
            translation: '코멘트는 영어, 스페인어, 일본어, 중국어, 한국어로 번역할 수 있습니다.',
            postComment: '코멘트 달기',
            updateComment: '코멘트 갱신하기',
            deleteComment: '코멘트 삭제하기',
            noComments: '코멘트가 없습니다',
            cuppingScoreHelpText: 'SCA 커핑 표를 통해 평가한 점수를 기입해주세요',
            more: '더 보기',
            ordered: '예약 완료',
            addInvoice: '청구서 작성',
            preOrderExplanation: '예약 접수 기간은 {{startedAt}} - {{endedAt}} 을 예정하고 있습니다.',
            countdownToOrder: '예약 개시까지 {{countdown}} 남았습니다',
            confirmationOfBuyPartial: 'Lot:{{lotNumber}}이 입찰한 수량에 미달하는 경우, 낙찰하지 않기',
            auctionBadgeExplanation: "\uC774 \uB86F\uC740 \uBE14\uB77C\uC778\uB4DC \uC625\uC158\uC5D0 \uCD9C\uD488\uB418\uC5B4 \uC788\uC2B5\uB2C8\uB2E4.\n\uC6D0\uD558\uC2DC\uB294 \uAD6C\uC785 \uAC00\uACA9\uACFC \uAC1C\uC218\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694.\n\uC2A4\uD0C0\uD2B8 \uAC00\uACA9\uC744 \uCD08\uACFC\uD55C \uAE08\uC561\uC740, \uACBD\uB9E4 \uBCF4\uB108\uC2A4\uB85C\uC11C \uC0DD\uC0B0\uC790\uC5D0\uAC8C \uC9C0\uAE09\uB418\uAC8C \uB429\uB2C8\uB2E4.\n\uC625\uC158\uC758 \uACB0\uACFC\uB294 \uD6C4\uC77C \uBA54\uC77C\uB85C \uC54C\uB824\uB4DC\uB9BD\uB2C8\uB2E4.\n\uBC30\uC9C0\uC758 \uC22B\uC790\uB294 \uD604\uC7AC \uAD6C\uB9E4 \uD76C\uB9DD\uC790\uC758 \uC218\uC785\uB2C8\uB2E4.",
            okagesamaNoMoriPrice: '* 참여 비용 {{ priceUsd }} (약 {{ price }})',
            okagesamaNoMoriPriceText: '(환율에 따라 참여 비용이 변동될 수 있습니다.)',
            sampleStats: '로스터가 주목중',
            preorderStats: '로스터가 구매함',
        },
        ordersPage: {
            title: '예약 목록',
            detailsTitle: 'Pre-orders details',
        },
        sampleOrdersPage: {
            title: '샘플 청구 목록',
        },
        register: {
            accept: '규약에 동의합니다',
        },
        orderedOfferLists: {
            title: '예약된 오퍼리스트',
        },
        sampleOrders: {
            title: '샘플 청구 목록',
            import: '샘플 청구 임포트',
        },
        sampleOrderedOfferLists: {
            title: '샘플 청구된 오퍼리스트',
        },
        orderDetail: {
            orderItemsTableTitle: '예약 롯 목록',
            bidsTableTitle: '입찰 롯 목록',
            changeStatus: 'Change status',
            preOrderRequestCreateOrEdit: '신청서를 작성하거나 편집하기',
        },
        sampleOrderDetail: {
            requestedLotNumbers: '샘플 청구한 Lot#',
        },
        invoice: {
            title: '예약 {{orderIds}}의 청구서',
            billingTo: '청구처',
            billingAddress: '청구처 주소',
            transparencyInformation: {
                farm: '생산자',
                farmExplanation: '생산자 정보는 <1>여기</1>을 참조해 주십시오.',
                mill: '정제소',
                millExplanation: '소규모 생산자로부터 구매한 커피 체리나 포장(파치먼트)은 생산지에서 정제됩니다. 여기에는 생산국 안에서의 수송 비용, 통관 비용도 포함되어 있습니다.',
                auctionBonus: '옥션 보너스',
                auctionBonusExplanation: '블라인드 경매를 통해 구매한 가격에서, 스타트 가격을 초과한 금액입니다. 이 금액은 경매 보너스로 생산자에게 지급됩니다.',
                shippingFee: '운송비용',
                shippingFeeExplanation: '운송비용과 수입비용(통관료,식물검역신청료 등)의 합계입니다.',
                importTax: '관세',
                importTaxExplanation: '운송비용과 상품대금의 합계의 {{ importTaxRate }}입니다.',
                typica: 'TYPICA',
                typicaExplanationForExclusiveLot: 'TYPICA의 보수입니다. ({{exclusiveTypicaHandlingRate}})',
                typicaExplanationByBagCount: 'TYPICA의 보수입니다.(5마대 미만 {{ lessThan5Bags }}, 5마대 이상 {{ moreThan5Bags }}, 10마대 이상 {{ moreThan10Bags }}, 50마대 이상 {{ moreThan50Bags }})',
                typicaExplanationByWeight: 'TYPICA의 보수입니다.（300Kg 미만: {{ lessThan300Kg }}, 300Kg 이상: {{ moreThan300Kg }}, 600Kg 이상: {{ moreThan600Kg }}, 3,000Kg 이상: {{ moreThan3000Kg }})',
                typicaExplanationForTypicaSelection: 'TYPICA의 보수입니다. (40%)',
                typicaExplanationForTypicaSelectionByWeightV1: 'TYPICA의 보수입니다. (300Kg 미만: 40%, 300Kg 이상: 35%, 600Kg 이상: 30%, 3,000Kg 이상: 25%)',
                typicaExplanationForTypicaSelectionByWeightV2: 'TYPICA의 보수입니다. (300Kg 미만: 35%, 300Kg 이상: 25%, 600Kg 이상: 20%, 3,000Kg 이상: 15%)',
                consumptionTaxExplanation: '과세 대상의 비용 및 수수료의 {{ taxRate }}입니다.',
                vatReverseChargeExplanation: 'VAT Reversed Charge (0%) 가 적용중입니다.',
                oldPriceVersionKgPriceNotice: '"후불 수수료 (비과세), 선불 결제 할인"및 "서비스료(비과세)"를 제외한 kg단가입니다.',
                newPriceVersionKgPriceNotice: '「결제 시기에 따른 할인 또는 수수료」를 제외한 kg단가 입니다.',
                specialTypicaDiscount: '할인',
                specialTypicaDiscountExplanation: '예약에 적용된 총 할인금액 입니다.',
                shippingFeeForJp: '수입 및 운송 비용',
                shippingFeeExplanationForJp: '선적항에서 양륙항, 공항까지 소요되는 비용입니다.',
                importTaxForJp: '수입 및 운송 비용',
                importTaxExplanationForJp: '선적지부터 창고까지 발생하는 운송 및 수입비용(통관비용, 식물검역료 등)의 합계 금액입니다.',
                consumptionTaxExplanationForJp: '생두의 8%, 해외운송비용 및 그 외 비용에 대하여 10%의 과세액의 합계입니다.',
                CoffeeCherryExplanation: 'Remarks',
                negativeBreakdownCoffeeCherryExplanation: 'As the cost of cherries of in Ethiopia continues to rise, it becomes increasingly difficult for washing stations, mills and exporters to stay profitable. {{producerName}}, however, believes that building long-term partnerships with roasters is important in the overall sustainability of the industry and so, in valuing those relationships, will be offering their coffee at an average price of the last few years, rather than raising it significantly.',
            },
            paidStatus: '결제 상태',
            paidMessage: '{{paidDate}} 에 결제 완료',
            unpaidMessage: '{{expiredDate}} 까지 결제해주세요',
            changePaymentMethod: '결제 방식을 변경',
            vatrcHelp: '프로필 화면에서 VAT 번호를 입력하면 VAT Reversed Charge가 적용됩니다.',
        },
        adminUsers: {
            title: 'Users',
        },
        adminRoasters: {
            title: '로스터 목록',
            typicaShareRatioCalculatedAt: 'TYPICA share ratio calculated at',
        },
        adminRoasterDetail: {
            title: 'Details for {{roaster}}',
        },
        adminProducers: {
            title: '생산자 목록',
        },
        adminProducerDetail: {
            title: 'Details for {{producer}}',
        },
        countryInformations: {
            title: '생산국 정보',
        },
        roasterCountries: {
            title: '판매국',
        },
        adminOrder: {
            title: '대리예약',
            selectRoaster: '로스터를 선택해주세요',
        },
        warehouses: {
            title: '창고관리',
        },
        warehouseItems: {
            title: '창고재고',
            deliveryRequest: '배송의뢰',
            addressInfo: '배송지 주소',
            selectItems: '배송 의뢰하고 싶은 Lot을 선택해 주세요',
            explainationForQuantity: '수량은 출하시의 포장 규격 단위로 표시되어 있으며, 예약시의 발주 단위와는 다릅니다',
            editDeliveryRequest: {
                caption: '배송 스케줄 조정이 필요하신가요?',
                button: '배송 스케줄을 수정',
            },
        },
        deliveryRequests: {
            title: '배송 의뢰 일람',
            import: 'Input delivery charges in a batch',
        },
        deliveryRequestDetail: {
            title: '배송 의뢰 상세',
            basicInfo: '기본정보',
            editForm: '편집 폼',
        },
        newDeliveryRequest: {
            title: 'Add New Delivery Request',
        },
        roasterWarehouseItems: {
            requestable: '배송가능수',
            delivered: '납품 완료수',
            delivering: '배송중',
        },
        offerListForum: {
            translateMessage: '메시지를 번역하기',
            changeTranslationLanguage: '번역 언어를 변경하기',
            languages: {
                en: '영어',
                es: '스페인어',
                ja: '일본어',
                zh: '중국어',
                ko: '한국어',
            },
        },
        monthlyClosing: {
            title: '월말 지불 목록',
            createButton: '월말 지불 처리',
        },
        balanceSheetEntry: {
            title: 'Balance Sheet Entries',
            advanceReceived: 'Advance Received',
        },
        offices: {
            title: '거점',
        },
        invoicePayment: {
            title: '청구서 "{{invoiceTitle}}" 의 결제',
            suspendedMessage: "\uC8C4\uC1A1\uD569\uB2C8\uB2E4.\n\n\uD604\uC7AC, \uACB0\uC81C \uC2DC\uC2A4\uD15C \uC774\uD589\uC5D0 \uB530\uB77C \uC2E0\uC6A9\uCE74\uB4DC \uACB0\uC81C\uB97C \uC77C\uC2DC \uC815\uC9C0\uD558\uACE0 \uC788\uC2B5\uB2C8\uB2E4.\n\uC774\uD589 \uC791\uC5C5\uAE4C\uC9C0 \uC7A0\uC2DC\uB9CC \uAE30\uB2E4\uB824 \uC8FC\uC2ED\uC2DC\uC624. \uC774\uD589\uC791\uC5C5 \uC644\uB8CC \uD6C4 \uACB0\uC81C\uD574 \uC8FC\uC2DC\uAC70\uB098, \uAE09\uD558\uC2E0 \uACBD\uC6B0 \uC740\uD589 \uC1A1\uAE08\uC744 \uD1B5\uD55C \uACB0\uC81C\uB97C \uBD80\uD0C1\uB4DC\uB9BD\uB2C8\uB2E4. \uBD88\uD3B8\uC744 \uB07C\uCCD0\uB4DC\uB824 \uC8C4\uC1A1\uD569\uB2C8\uB2E4.\n",
        },
        transportToWarehouse: {
            waterActivity: '수분활성도',
            moistureContent: '수분량',
        },
        adminAuction: {
            title: '{{offerListName}} / {{lotNumber}}의 경매 상황',
            auctionClosed: '이 경매는 이미 종료되었습니다',
            auctionOpened: '이 경매는 개최중입니다',
            closeAuction: '경매를 종료하다',
            confirmation: 'This auction will be closed. Bids cannot be canceled after the auction is closed. Do you want to proceed?',
        },
        roasterBids: {
            title: '입찰 목록',
        },
        roasterAuction: {
            title: '{{offerListName}} / {{lotNumber}}의 경매결과',
            bidQuantity: '낙찰한 수량',
            roasterAuctionResult: '낙찰 결과',
            auctionResult: '전체 낙찰 결과',
        },
        adminCreateTypicaStockItems: {
            title: 'Create TYPICA Selection',
        },
        adminTypicaStockItems: {
            title: 'TYPICA Selection',
            helpQuantity: 'The total number of typica stock. This value is reflected when creating contracts such as Shipping instructions.',
            helpRemainingQuantity: 'Quantity - Ordered Quantity + Adjustment Quantity',
            helpAdjustmentQuantity: 'For adjusting the number of items in typica stock (e.g., to reduce the number of items in stock for sample requests)',
            helpSampleRemainingQuantity: 'Sample total quantity - Sample ordered quantity',
        },
        adminNewTypicaStockOrder: {
            title: 'Proxy pre-order from TYPICA Selection',
        },
        adminTypicaStockOrders: {
            title: 'TYPICA Selection pre-orders',
        },
        adminTypicaStockSampleOrders: {
            title: 'TYPICA Selection sample requests',
        },
        adminSalesContractAndAuctionBonusInvoice: {
            title: 'Sales Contract / Auction Bonus Invoice',
        },
        adminSalesContractBankAccount: {
            title: 'Producer Bank account information for salesContract',
        },
        producerBankAccounts: {
            title: '계좌 정보 목록',
            edit: '계좌 정보 편집',
            new: '계좌 정보 작성',
        },
        producerOkagesamaNoMori: {
            title: 'OKAGESAMA',
        },
        adminRoasterSalesReward: {
            title: 'Roaster Sales Reward',
            netWeight: 'Weight',
            quantity: 'Quantity',
        },
        typicaSelection: {
            title: 'TYPICA 셀렉션',
            order: '상세 가격 확인하기',
            sampleOrderPeriod: '상시',
            orderPeriod: '상시',
            paymentPeriod: '납품후 후불',
            estimatedDeliveryPeriod: '예약 후 1주일 정도',
            sampleOrder: '샘플 청구는 여기에서',
            orderFormStepper: {
                order: '지불 & 청구처 주소',
                deliveryRequest: '배송 지정',
            },
            tooltip: {
                invalidDeliveryRequestGroup: {
                    oneTime: {
                        body1: '도착 예정일이 빈칸입니다',
                        body2: '도착 예정일을 지정해주세요',
                    },
                    installment: {
                        body1: '배송 의뢰가 가능한 Lot이 남아있습니다',
                        body2: '분할 납품의 모든 배송시기를 지정해 주십시오',
                    },
                },
                isNotWarehousing: {
                    body1: '아직 입고되지 않았습니다',
                    body2: '입고된 Lot 이외에는 배송시기를 지정할 수 없습니다',
                },
                inValidDeliveryRequestItemsAndRequestDate: '배송 마대수 또는 도착 예정일을 입력해주세요',
            },
        },
        preOrderRequest: {
            title: '재구매 신청 목록',
            new: '재구매 신청서 작성',
            requestedOffer: 'Requested for repeat order Lot',
            lotNumberBlank: '동일 오퍼리스트 안에서 주문하기',
        },
        roasterAddresses: {
            title: '주소록 관리',
            billingAddresses: '청구지 주소',
            deliveryAddresses: '배송 주소',
        },
        cuppingComments: {
            title: '커핑 요약',
            commentedBy: '커핑 로스터',
            otherRoasters: '다른 {{ count }}명의 로스터를 표시',
        },
        createCuppingComment: {
            title: '코멘트를 작성하기',
        },
        deliveryRequestItemsAndRequestDateForm: {
            title: '',
            subheaders: {
                oneTime: '배송 지정',
                installment: '배송 예정 시기에 일괄 납품합니다.',
                installmentCaption: '배송 예정 시기부터 최대 3회로 분할하여 납품합니다.',
            },
            type: {
                oneTime: '일괄 납품',
                installment: '분할 납품',
            },
            changeTimings: '{{ timing }}으로 변경',
            buttons: {
                new: '배송시기 설정',
                add: '배송시기 추가',
            },
            captions: {
                datePicker: {
                    fastestDelivery: '* 빈칸이 있는 경우 최단시간에 배송됩니다.',
                    main: {
                        deliveryDateExplanation: '* 오늘부터 {{ startWeek }} 이후 날부터, 배송의뢰일로부터 5개월 이내의 날짜를 설정하실 수 있습니다.',
                        startWeek1: '1주간',
                        startWeek2: '2주간',
                    },
                    sub: {
                        europe: '* 도착예정일은 지역에 따라 실제 배송이 평균 2주 정도 지연될 수 있으므로 빠른 배송일 지정을 권장하고 있습니다. 양해 부탁드립니다.',
                        etc: '* 도착예정일은 지역에 따라 실제 배송이 1주일 정도 지연될 수 있으므로 빠른 배송일 지정을 권장하고 있습니다. 양해 부탁드립니다.',
                    },
                },
                card: '* 신선한 상태로 배송하기 위해 일괄 납품을 권장하고 있습니다. 고객님의 사정에 따라 분할 납품을 선택하실 수 있습니다.',
            },
            dialog: {
                title: '배송시기',
            },
        },
        adminWarehouseHoliday: {
            title: 'Warehouse holidays',
        },
    },
    labels: {
        stock: '구입 가능한 수량',
        stockUnit: '마대',
        lotRef: 'LOT',
        offerListSummary: '오퍼 요약',
        farmWithLink: '농장',
        curatorName: '큐레이터명',
        seller: '출품자',
        material: '소개 자료',
        story: '인터뷰',
        period: '오퍼 기간',
        activeOfferLists: '공개중',
        preparingOfferLists: '공개 준비중',
        expiredOfferLists: '접수 종료',
        noData: '데이터를 찾을 수 없었습니다',
        paymentTimingOnAdmin: '지불 시기',
        fullAddress: '주소',
        deliveryItems: '배송 리스트 (Lot: 수량)',
        all: '전부',
        inStock: '재고수',
        forum: '게시판',
        forumDisplayName: '게시판 표시명',
        taxed: '과세 대상입니다',
        paymentTimingHandlingFee: {
            negativeValue: '할인',
            positiveValue: '결제 수수료',
        },
        paid: '결제 완료',
        exported: '수출 시점',
        imported: '수입 시점',
        uploadContract: '업로드 할 계약서를 선택해 주세요',
        uploadDocuments: '업로드할 파일을 선택해주세요',
        uploadBusinessNumberKrdocument: '사진을 첨부하기',
        selectFoundingCurator: 'Input Founding curator name',
        pending: '미정',
        newRoasterCampaignDiscount: '첫 구매 할인',
        couponTarget: '쿠폰 적용중',
        newRoasterCampaignUnderway: '첫 구매 한정 이벤트 진행중!',
        agree: '위 주의사항에 동의합니다',
        memo: '메모',
        tradeCountryUsages: '용도',
        tradeCountryProcessings: '프로세스 / 정제 방법',
        tradeCountryPriceRanges: '가격대',
        uneditableJoinedInOkagesamaNoMori: 'Cannot edit joined in OKAGESAMA with active offer lists',
        contributedToOkagesamaNoMori: '* OKAGESAMA에 참가하셨습니다',
        default: '기본값',
        billingAddress: '청구지 주소',
        deliveryAddress: '배송 주소',
        deliveryRequestFormRequestDate: '도착예정일',
        fastestDeliveryRequest: '가장 빠른 배송',
        deliveryRequestByDate: '날짜지정 배송',
        includesItems: 'Include invoice items',
        bulkDownloadMode: 'Bulk download mode',
        miscFeeForJp: '그외 수수료*2',
        taxNodeForJpCalculation: '*1은 8%과세대상 / *2는 10%과세대상 / *3은 부과세대상',
    },
    buttons: {
        yes: '네',
        no: '아니오',
        create: '작성',
        update: '갱신하기',
        delete: '삭제',
        cancel: 'Cancel',
        apply: 'Apply',
        complete: '완료',
        resetPassword: '패스워드 재설정하',
        changePassword: '패스워드 변경하기',
        reconfirmEmail: '확인 메일을 재발송하기',
        chooseFile: '파일을 선택해주세요',
        upload: '업로드',
        calculateFixed: '최종가격을 확정하기',
        cancelFixed: '최종가격의 확정을 취소하기',
        pay: '입금확인완료로 설정하기',
        unpay: '입금확인완료를 해제하기',
        downloadInvoice: '청구서 다운로드',
        salesContractDownloadPdf: 'Sales Contract 다운로드',
        auctionBonusInvoiceDownloadPdf: 'Action Bonus Invoice 다운로드',
        downloadCsv: 'CSV 다운로드',
        deliveryRequest: '배송 의뢰',
        processing: '처리중...',
        import: '임포트',
        addItem: 'Add Item',
        createContracts: '계약서 작성',
        changeStatusTo: '{{status}}로 변경',
        setBankAccount: '계좌 정보 설정',
        bankAccount: '계좌 정보',
        selectFoundingCurator: 'Select Founding curator',
        changeFoundingCurator: 'Change Founding curator',
        deleteFoundingCurator: 'Cancel Founding curator',
        salesReward: 'Sales Reward',
        manageCommunityManager: 'Manage Community Manager',
        stripePayment: '결제하기',
        taiwanApiResponse: {
            resend: 'Resend(Government Uniform Invoices)',
            update: 'Set success without resend(Government Uniform Invoices)',
            destroy: 'Remove success(Government Uniform Invoices)',
        },
        priceDetail: '상세 가격 확인하기',
        setAsDefault: '기본값으로 설정',
        selectAll: 'Select all',
        deselectAll: 'Deselect all',
        next: '다음으로',
        updateNow: 'Update now',
        downloadOffersCsv: 'Download all lots',
    },
    links: {
        login: '로그인은 이쪽에서',
        register: '신규 등록은 이쪽에서',
        resetPassword: '패스워드를 잊어버린 경우는 이쪽',
        reconfirmEmail: '확인 메일의 재발송은 이쪽에서',
        back: '돌아가기',
        payFromHere: '지불은 이쪽에서',
        story: '이야기',
        movie: '동영상',
        privacy_policy: '프라이버시 정책',
        specified_commercial_transactions_law: '특정 상거래법에 의거한 표시에 대해',
        tos: '이용약관',
        trackingUrl: '배송 상황',
        cookiePolicy: 'Cookie 정책',
    },
    messages: {
        registerSuccess: '메일 주소의 유효여부 확인을 위해 {{email}}로 메일을 보냈습니다. 메일에 기재된 링크로 등록을 완료해 주세요.',
        confirmationSuccess: '메일 주소의 인증을 확인했습니다. 설정된 메일 주소, 패스워드로 로그인해 주세요',
        unlockSuccess: '계정 잠금이 해제되었습니다.',
        resetPasswordSuccess: '패스워드 재설정을 접수했습니다. 메일로 연락 드리니 확인해 주세요.',
        accountUpdateSuccess: '계정 정보의 편집을 접수했습니다. 메일로 연락드리니 확인해 주세요.',
        changePasswordSuccess: '비밀번호를 변경하였습니다.',
        reconfirmEmailSuccess: '확인 메일의 재발송을 접수받았습니다. 메일로 연락드리니 확인해 주세요.',
        invalidEmail: '올바른 이메일을 입력해주세요',
        invalidPostalCode: '우편번호는 숫자로만 입력해주세요',
        loginSuccess: '로그인했습니다',
        logoutSuccess: '로그아웃했습니다',
        uploadSuccess: 'CSV 업로드를 변경했습니다',
        createSuccess: '작성했습니다',
        updateSuccess: '갱신했습니다',
        deleteSuccess: '삭제했습니다',
        updateFailure: '실패했습니다',
        deleteConfirm: '삭제하겠습니다. 정말 괜찮으시겠습니까?',
        rejectConfirm: 'This will cancel the bid for failing the screening. Are you really sure?',
        bidCancelConfirm: '입찰을 취소합니다. 정말 괜찮으시겠습니까?',
        orderSuccess: '주문했습니다',
        typicaStockOrderSuccess: '주문이 완료되었습니다. 이미 입고된 물품은 창고의 재고 목록에서 배송을 의뢰하실 수 있습니다.',
        sampleOrderSuccess: '샘플을 예약했습니다',
        deliveryRequestSuccess: '배송 의뢰했습니다. 발송 준비가 완료한 뒤 다시 연락드리겠습니다',
        cancelConfirm: '한번 취소하면 추후 변경은 불가능합니다.정말 괜찮으시겠습니까?',
        calculateFixed: "\uB85C\uC2A4\uD130\uB85C\uBD80\uD130\uC758 \uC608\uC57D \uC2E0\uCCAD\uC744 \uC2B9\uC778\uD574, \uB9E4\uB9E4 \uACC4\uC57D\uC744 \uC131\uB9BD\uC2DC\uD0A4\uACA0\uC2B5\uB2C8\uB2E4.\n\uAE08\uC561\uC774 \uD2C0\uB9BC \uC5C6\uB294\uC9C0 \uB2E4\uC2DC \uD55C\uBC88 \uD655\uC778\uD574 \uC8FC\uC138\uC694.\n\uCD5C\uC885 \uAC00\uACA9\uC744 \uD655\uC815\uD574\uB3C4 \uB418\uACA0\uC2B5\uB2C8\uAE4C?",
        calculateFixedSuccess: '대상 예약의 최종 가격을 확정했습니다.',
        cancelFixed: "\uC131\uB9BD\uB41C \uB85C\uC2A4\uD130\uC640\uC758 \uB9E4\uB9E4\uACC4\uC57D\uC744 \uD30C\uAE30\uD569\uB2C8\uB2E4.\n\uACC4\uC57D \uD30C\uAE30\uC5D0\uB294 \uB9AC\uC2A4\uD06C\uAC00 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.\n\uC815\uB9D0 \uCDE8\uC18C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
        cancelFixedSuccess: '최종 가격 확정을 취소했습니다.',
        commentSuccess: '코멘트를 달았습니다',
        deleteCommentConfirmTitle: '코멘트 삭제',
        deleteCommentConfirmBody: '코멘트를 삭제합니다. 정말 괜찮으시겠습니까?',
        changePasswordTokenError: '패스워드 재설정의 유효기간이 지났습니다.다시 재설정 해 주세요.',
        deleteInvoiceConfirmTitle: '청구서의 삭제',
        deleteInvoiceConfirmBody: '청구서를 삭제합니다. 정말 괜찮으시겠습니까?',
        deleteInvoiceItemConfirmTitle: '청구명세 삭제',
        deleteInvoiceItemConfirmBody: '청구명세를 삭제합니다. 정말 괜찮으시겠습니까?',
        sendInvoiceMailConfirmTitle: '메일 알림',
        sendInvoiceMailConfirmBody: '로스터에게 청구서가 발행되었다고 메일을 보냅니다. 정말 괜찮으시겠습니까?',
        sentSuccess: '메일을 보냈습니다.',
        payConfirmTitle: '입금확인 완료로 설정하기',
        payConfirmBody: '입금확인 완료로 설정합니다. 정말 괜찮으시겠습니까?',
        unpayConfirmTitle: '입금확인 완료를 해제한다',
        unpayConfirmBody: '입금확인 완료 해제를 합니다. 정말 괜찮으시겠습니까?',
        nRowsSelected: '{0}건을 선택 중입니다',
        noDeliveryRequest: '배송 의뢰가 없습니다',
        invalidOrderCombination: '샘플청구와 예약은 동시에 불가능합니다.',
        orderExplanationTitle: '예약에 관한 유의사항',
        sampleOrderExplanationTitle: '샘플 청구에 관한 주의사항',
        auctionOrderExplanationTitle: '경매 예약에 관한 주의사항',
        sampleOrderExplanationBody: "\uC0D8\uD50C \uBB3C\uB7C9\uC774 \uD55C\uC815\uB418\uC5B4 \uC788\uAE30 \uB54C\uBB38\uC5D0, \uC0D8\uD50C \uCCAD\uAD6C\uB294 \uAD6C\uC785\uC744 \uD76C\uB9DD\uD558\uC2DC\uB294 \uBD84\uC744 \uB300\uC0C1\uC73C\uB85C \uD558\uACE0 \uC788\uC2B5\uB2C8\uB2E4.\n\uB610\uD55C, \uC804\uAD6D \uAC01\uC9C0\uC5D0\uC11C \uBAA8\uB4E0 \uB86F\uC744 \uCEE4\uD551\uD574\uBCF4\uC2E4 \uC218 \uC788\uB294 '\uCEE4\uBBA4\uB2C8\uD2F0 \uCEE4\uD551' \uC744 \uAC1C\uCD5C\uD558\uACE0 \uC788\uC2B5\uB2C8\uB2E4.\n\uC790\uC138\uD55C \uC0AC\uD56D\uC740 \uBA54\uC77C\uC744 \uD1B5\uD55C \uC548\uB0B4\uB97C \uD655\uC778\uD558\uC5EC \uC8FC\uC138\uC694.",
        deliveryTimeExplanationTitle: '배송 관련 주의사항',
        deliveryTimeExplanationForUsBody: "* There are additional costs associated with last-mile delivery from RPM warehouse in NJ via Accurate Transport.\n    * Please click <0>here</0> for delivery charges and <1>here</1> for delivery time.\n    * Arranging your own local shipping company or picking up at the warehouse are also possible. If so, please indicate this in the Note.\n    * Delivery could be delayed by logistical problems.\n    * Please feel free to ask if you have any questions.",
        deliveryTimeExplanationBody: "* \uAD6D\uB0B4 \uBC30\uC1A1\uC694\uAE08\uC740 \uBCC4\uB3C4\uB85C \uCCAD\uAD6C\uB429\uB2C8\uB2E4.\n[\uAC00\uC7A5 \uBE60\uB978 \uBC30\uC1A1 \uC2E0\uCCAD\uC2DC]\n. \uC624\uD6C4 4\uC2DC \uC774\uC804 \uC811\uC218 \uAC74 : 1\uC77C \uD6C4 \uCD9C\uACE0\n. \uC624\uD6C4 4\uC2DC \uC774\uD6C4 \uC811\uC218 \uAC74 : 2\uC77C \uD6C4 \uCD9C\uACE0\n. (\uC601\uC5C5\uC77C \uAE30\uC900, \uB3C4\uCC29 \uC608\uC0C1\uC77C\uC740 \uCD9C\uACE0 \uD6C4 1~2\uC77C(\uC81C\uC8FC\uB3C4 \uC81C\uC678\uFF09)\n* \uC720\uD1B5 \uC0AC\uC815\uC5D0 \uC758\uD574 \uC608\uC815\uBCF4\uB2E4 \uB0A9\uD488\uC774 \uB2A6\uC5B4\uC9C0\uB294 \uACBD\uC6B0\uAC00 \uC788\uC2B5\uB2C8\uB2E4.\n* \uB9C8\uB300 \uBB34\uAC8C\uC5D0 \uB530\uB77C \uBC30\uC1A1\uBE44\uAC00 \uB2EC\uB77C\uC9C8 \uC218 \uC788\uC2B5\uB2C8\uB2E4.\n* \uC81C\uC8FC\uB3C4 \uBC0F \uB3C4\uC11C \uC0B0\uAC04\uC9C0\uC5ED\uC740 \uBC30\uC1A1\uBE44\uAC00 \uCD94\uAC00\uB85C \uBC1C\uC0DD\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.\n* \uC8FC\uB9D0 \uBC0F \uACF5\uD734\uC77C\uC5D0\uB294 \uC9D1\uD558 \uBC0F \uBC30\uC1A1\uC744 \uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.\n* \uD314\uB808\uD2B8\uC758 \uC0AC\uC6A9\uC740 \uB530\uB85C \uC2E0\uCCAD\uC774 \uD544\uC694\uD558\uBA70, \uCD94\uAC00 \uC694\uAE08\uC774 \uBC1C\uC0DD\uD569\uB2C8\uB2E4.\n* \uBB38\uC758\uC0AC\uD56D\uC774 \uC788\uC73C\uC2DC\uB2E4\uBA74 \uC5B8\uC81C\uB4E0\uC9C0 \uC5F0\uB77D\uD574\uC8FC\uC2ED\uC2DC\uC624.",
        orderExplanationForUsBody: "* Please refer to <0>our terms and conditions</0> before proceeding with pre-orders.\n\n    * Pre-order pricing is ex-warehouse.\n    There are additional costs associated with last-mile delivery from RPM warehouse in NJ via Accurate Transport.\n    Please see <1>this file</1> for delivery costs by destination in NYC area.\n    Kindly note that shipping fees for delivery outside of New York, New Jersey, Maryland, Delaware, and Washington D.C. will be confirmed once we obtain a quote from the delivery company.\n\n    * An estimated delivery date may be delayed due to circumstances in production areas or distribution channels.\n\n    * The quality of the product shall be the same as the sample.\n\n    * As green coffee production is strongly affected by the situation and climate of production areas, conditions may be subject to change. Please note that this pre-order does not immediately guarantee the conclusion of your order. We will send you confirmation of your order after the end of a pre-order period.",
        orderExplanationBody: "* \uC608\uC57D\uC5D0 \uAD00\uD55C \uC720\uC758\uC0AC\uD56D\n\n* \uC608\uC57D \uC804 \uBC18\uB4DC\uC2DC <0>\uC774\uC6A9\uC57D\uAD00</0>\uC744 \uD655\uC778\uD558\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.\n\n* \uAD6D\uB0B4 \uBC30\uC1A1\uBE44\uAC00 \uBCC4\uB3C4\uB85C \uBC1C\uC0DD\uD569\uB2C8\uB2E4.\n\n* \uC0DD\uC0B0\uC9C0\uB098 \uBC30\uC1A1 \uC0C1\uD669\uC5D0 \uB530\uB77C, \uC608\uC0C1 \uB3C4\uCC29\uC77C\uC774 \uBCC0\uACBD\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4.\n\n* \uC0C1\uD488\uC758 \uD488\uC9C8\uC740, \uC0D8\uD50C\uC5D0 \uC900\uD558\uB294 \uAC83\uC73C\uB85C \uD569\uB2C8\uB2E4.\n\n* \uCEE4\uD53C \uC0DD\uB450\uC758 \uC0DD\uC0B0\uC5D0 \uC788\uC5B4 \uC0DD\uC0B0\uC9C0\uC758 \uC0C1\uD669\uC774\uB098 \uAE30\uD6C4\uC758 \uC601\uD5A5\uC744 \uAC15\uD558\uAC8C \uBC1B\uAE30 \uB54C\uBB38\uC5D0, \uC608\uC57D \uAE30\uAC04 \uC885\uB8CC \uC774\uD6C4 \uBCF8 \uACC4\uC57D\uC758 \uC131\uB9BD\uC774 \uD655\uC57D\uB428\uC744 \uC54C\uB824\uB4DC\uB9BD\uB2C8\uB2E4.\n\n\uBC30\uC1A1\uB8CC\uFF08\uD55C \uB9C8\uB300 \uAE30\uC900\uFF09\n~ 35KG : 15,000\uC6D0\n36KG ~ 60KG : 30,000\uC6D0\n61KG ~ 70KG : 40,000\uC6D0\n(\uC81C\uC8FC\uB3C4\uB294 \uCD94\uAC00 \uBC30\uC1A1\uB8CC\uAC00 \uC801\uC6A9\uB429\uB2C8\uB2E4.)\n(\uD314\uB808\uD2B8\uB97C \uC0AC\uC6A9\uD558\uC2DC\uB294 \uBD84\uAED8\uC11C\uB294 \uCEE4\uBBA4\uB2C8\uD2F0 \uB9E4\uB2C8\uC800\uC5D0\uAC8C \uC5F0\uB77D\uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.)",
        createdInvoices: '{{count}}건의 청구서가 생성되었습니다',
        orderNotStarted: '예약 접수는 {{startedAt}} 에 시작합니다',
        createContractsTitle: 'Preparation of contract documents',
        createContractsBody: "This will create the templates for the contract documents.\nPlease make sure that you have not forgotten to create TYPICA Stock.\nDo you want to proceed?",
        changeContractStatusToPublished: 'Set to Published. If you make it issued, it will be published to the producer and you will be notified by email. Are you sure?',
        changeContractStatusToDraft: 'Set to draft. Are you sure?',
        salesContractDownloadExplanationTitle: 'SalesContract의 다운로드에 관한 안내사항',
        salesContractDownloadExplanationBody: "SalesContract\uB97C \uB2E4\uC6B4\uB85C\uB4DC\uD558\uAE30 \uC804\uC5D0 \uACC4\uC88C \uC815\uBCF4\uB97C \uC124\uC815\uD574\uC57C \uD569\uB2C8\uB2E4.\n\uACC4\uC88C \uC815\uBCF4\uB97C \uC120\uD0DD\uD558\uC2E0 \uB4A4, \uBCC4\uB3C4 \uC8FC\uC758\uC0AC\uD56D \uB4F1\uC774 \uC788\uC744 \uACBD\uC6B0 \uAE30\uC7AC\uD574 \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.",
        addBankAccountInformation: "SalesContract\uB97C \uB2E4\uC6B4\uB85C\uB4DC \uBC1B\uAE30 \uC704\uD574\uC11C\uB294 \uACC4\uC88C \uC815\uBCF4\uB97C \uB4F1\uB85D\uD574\uC57C \uD569\uB2C8\uB2E4.\n\uC544\uB798 \uB9C1\uD06C\uB97C \uD1B5\uD574 \uACC4\uC88C \uC815\uBCF4\uB97C \uB4F1\uB85D\uD574\uC8FC\uC138\uC694.",
        createBankAccount: '계좌 정보를 작성하였습니다',
        orderedOfferNotExist: '아직 예약한 Lot이 없습니다',
        stripeConfirmBody: '결제합니다. 정말 괜찮으시겠습니까?',
        updateSuccessInvoicePaid: '결제가 완료되었습니다. 청구서가 결제 완료 상태로 변경되기까지 조금 시간이 걸릴 수 있습니다. 양해를 부탁드립니다.',
        deliverySampleWarningMessage: '샘플은 상품이 입고된 후에 발송이 가능합니다. 입고 예정시기는 {{ approvalDate }}입니다.',
        deliverySampleWarningConfirmationMessage: '이하의 샘플은 상품이 입고된 후에 발송됩니다.',
        contactToTypicaMessage: '문의사항이 있으시다면 아래 이메일 주소로 문의 주세요',
        contactToTypicaMailSubject: 'TYPICA Direct Trade Platform',
        selectColumns: 'Select Columns',
        exchangeRateMoreThanHighestRateOnPrevMonth: 'The exchange rate exceeds the highest rate ({{ rate }}) for the previous month. Are you sure?',
        exchangeRateLessThanLowestRateOnPrevMonth: 'The exchange rate is below the lowest rate ({{ rate }}) of the previous month. Are you sure?',
        updateRequired: 'New version {{ version }} found! Reload after 5 seconds...',
        newPlatformRegisterNotice: '2024년 8월 6일에 새로운 플랫폼으로 전환했습니다. 등록하려면 <0>여기</0>를 클릭하세요.',
        newPlatformNotice: '2024년 8월 6일부터 새로운 플랫폼으로 전환됩니다. <0>이곳</0>을 이용해 주세요.',
        newPlatformSampleNotice: '새로운 플랫폼의 샘플 청구 목록은 <0>이곳</0>에서 확인할 수 있습니다.',
        newPlatformOrderNotice: '새로운 플랫폼의 예약 목록은 <0>이곳</0>에서 확인할 수 있습니다.',
        newPlatformInvoiceNotice: '새로운 플랫폼의 인보이스는 <0>이곳</0>에서 확인할 수 있습니다.',
        newPlatformProfileNotice: "\uC5EC\uAE30\uC11C \uC5C5\uB370\uC774\uD2B8\uB41C \uC815\uBCF4\uB294 \uC0C8\uB85C\uC6B4 \uD50C\uB7AB\uD3FC\uC73C\uB85C \uC790\uB3D9 \uBC18\uC601\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.\n\uBD88\uD3B8\uD558\uC2DC\uACA0\uC9C0\uB9CC, <0>\uC0C8\uB85C\uC6B4 \uD50C\uB7AB\uD3FC\uC5D0\uC11C</0> \uC5C5\uB370\uC774\uD2B8\uD574 \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.",
    },
    errors: {
        isRequired: '{{ field }}을(를) 입력해주세요',
        invalid: '{{ field }}은(는) 잘못된 값입니다',
        positive: '{{ field }}은(는) 1이상을의 숫자를 입력해주세요',
        integer: '{{ field }}은(는) 숫자를 입력해주세요',
        decimal: '{{ field }}은(는) 숫자 및 .(소수점)으로 입력해주세요',
        alphanumeric: '{{ field }}은 영숫자로 입력해주세요',
        invalidPostalCode: 'Postal code must be alphanumeric 7 characters',
        invalidCity: 'City must be 12 double-byte characters or less',
        invalidAddress: '{{ field }} must be full-width {{ fullWidthMaxLength }} character/half-width {{ halfWidthMaxLength }} character or less',
        purchaseLimitError: '본 Lot의 구입상한은 {{ limit }}개 입니다',
        lowestBidFobPriceError: '입력한 가격이 스타트 가격보다 적습니다',
        totalFeeUpperLimitError: '신용카드의 결제 한도를 초과했습니다. 계좌 이체로 지불 방법을 변경하시거나, 합계 금액이 10,000,000원 이하가 되도록 변경을 부탁드립니다.',
        noStock: '재고가 부족합니다',
        sameTypicaStockItemExists: 'Same Lot and warehouse combination already exists',
        mustOverOfferMinOrderWeight: 'Lot의 주문 단위  {{ minOrder }} 이상의 중량을 입력해 주세요',
        notSelectableLessThanOrdersTotalWeight120Kg: '120kg 이상 예약시 선택이 가능합니다',
    },
    options: {
        isExists: {
            '1': '있음',
            '0': '없음',
        },
        isQGrader: {
            '1': '큐 그레이더 자격 소지자',
            '0': '큐 그레이더 자격 미소지자',
        },
    },
    stripePayment: {
        failure: '결제에 실패했습니다. 처음부터 다시 시작해주세요.',
        afterStatusSucceeded: '결제가 이미 완료되어 있습니다. 결제 완료 상태로 변경되기까지 조금 시간이 걸릴 수 있습니다. 양해를 부탁드립니다.',
    },
    tradeCountryUsages: {
        filter: 'Filter',
        espresso: 'Espresso',
        omniroast: 'Omniroast',
        blend_component: 'Blend component',
    },
    tradeCountryProcessings: {
        washed: 'Washed',
        honey: 'Honey',
        natural: 'Natural',
        washed_anaerobic: 'Washed Anaerobic',
        natural_anaerobic: 'Natural Anaerobic',
        experimental: 'Experimental',
    },
    tradeCountryPriceRanges: {
        '5_to_10_dollars': '$5~10',
        '10_to_15_dollars': '$10~15',
        '15_to_20_dollars': '$15~20',
        '20_to_30_dollars': '$20~30',
        '30_dollars_or_more': '$30~',
    },
};
